import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { AccountMenuSkeleton } from '@ciceksepeti/cs-account-menu-skeleton';
import '@ciceksepeti/cs-account-menu-skeleton/styles.css';
import Fragment from '@components/fragment';
import { useResponsive } from '@hooks/use-responsive';
import styles from './styles.module.scss';
var AccountMenu = function () {
    var _a;
    var isTabletDesktop = useResponsive().isTabletDesktop;
    var accountMenuSkeletonWrapperCn = classNames((_a = {},
        _a[styles.accountMenuSkeletonWrapper] = isTabletDesktop,
        _a));
    return (_jsx(Fragment, { scope: "ciceksepetiAccountMenu", skeleton: _jsx("div", { className: accountMenuSkeletonWrapperCn, children: _jsx(AccountMenuSkeleton, {}) }) }));
};
export default AccountMenu;
